export const intro = (introRan, isHomepage) => {

  const introelement = document.getElementById("intro");

  const init = () => {

    if (introRan) {
      if (isHomepage == true) {
        console.log("This page contains intro element");
        introelement.style.display = "block";
      } else {
        console.log("Hide the intro");
        introelement.style.display = "none";
      }
    }

    if (introRan == false) {
      bind();
    }

  };

  const bind = () => {

    //Do things related to intro

  };

  if (typeof introelement != "undefined" && introelement != null) {
    init();
  }
  
};
